import styled from '@emotion/styled';
import { forwardRef } from 'react';
import { ReactComponent as Logo } from '../svgs/logo.svg';
import Navbar from './Navbar';

const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const HeaderInner = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
`;

const Separator = styled.hr`
  border: 0.5px solid white;
  display: block;
  flex: 1;
  margin: 30px 20px;
  border-radius: 20px;
`;

const Header = forwardRef<HTMLDivElement>((_, ref) => {
  return (
    <HeaderWrapper ref={ref}>
      <HeaderInner>
        <Logo width={42} height={52} />
        <Navbar />
      </HeaderInner>
      <Separator />
    </HeaderWrapper>
  );
});

export default Header;
